import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'app-modal-transactions',
  templateUrl: './modal-transactions.component.html',
  styleUrls: ['./modal-transactions.component.scss']
})
export class ModalTransactionsComponent implements OnInit {

  form!: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder
  ) { }

  ngOnInit() {
    // Creamos un FormArray con un FormGroup por cada transacción
    this.form = this.fb.group({
      transactions: this.fb.array(
        this.data.transactions.map(item => this.fb.group({}))
      )
    });
  }

  get controls() {
    return (this.form.get('transactions') as FormArray).controls;
  }
}